let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dnObq")).then(() => parcelRequire('4RP7y'));